var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goal-preview__container"},[_c('p',[_c('b',[_vm._v(_vm._s(_vm.title)+" ")])]),_c('div',{staticClass:"goal-preview__text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }